import { render, staticRenderFns } from "./DetalleAlarma.vue?vue&type=template&id=21b1f521&scoped=true&"
import script from "./DetalleAlarma.vue?vue&type=script&lang=js&"
export * from "./DetalleAlarma.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAlarma.vue?vue&type=style&index=0&id=21b1f521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1f521",
  null
  
)

export default component.exports